module.exports = __webpack_public_path__ + "static/media/event4.57e9ae7a.jpg";